import React, { Component } from "react";
import { Link } from "react-router-dom";
import { HomeImages } from './homeImages'

class FeaturedIn extends Component {

	constructor(props) {
		super(props);
		this.state = {

		}
	}

	render() {
		return (
			<section className="feartured-in">
				<div className="rounded-top-corner"></div>

				<div className="rounded-top-right-corner"></div>

				<div className="rounded-bottom-left-corner"></div>

				<div className="rounded-bottom-right-corner"></div>

				<div className="feartured-in-wrap">
				<h2>Featured in...</h2>
					<ul>
						
						<li className="fadeInLeft animated delay-1s">
							<img src={HomeImages.Fox_news.url} alt={"Fox_news"} />
						</li>

						<li className="fadeInLeft animated delay-1s">
							<img src={HomeImages.NBC_news.url} alt={"NBC_news"} />
						</li>

						<li className="fadeInLeft animated delay-1s">
							<img src={HomeImages.cbs_news.url} alt={"cbs_news"} />
						</li>

						 
						<li className="fadeInLeft animated delay-1s">
							<img src={HomeImages.abc_news.url} alt={"abc-news"} />
						</li>

						<li className="fadeInLeft animated delay-1s">
							<img src={HomeImages.authority_magazine.url} alt={"authority-magazine"} />
						</li>

						<li className="fadeInLeft animated delay-1s">
							<img src={HomeImages.entrepreneur.url} alt={"entrepreneur"} />
						</li>

						<li className="fadeInRight animated delay-1s">
							<img src={HomeImages.home_business.url} alt={"home-business"} />
						</li>

						<li className="fadeInRight animated delay-1s">
							<img src={HomeImages.yahoo_finance.url} alt={"yahoo-finance"} />
						</li>

						<li className="fadeInRight animated delay-1s">
							<img src={HomeImages.thrive_global.url} alt={"thrive-global"} />
						</li>

						<li className="fadeInRight animated delay-1s">
							<img src={HomeImages.martech_series.url} alt={"martech-series"} />
						</li>

					</ul>
				</div>
			</section>
		);
	}

};

export default FeaturedIn;